export default {
  masterChef: {
    882688: '0x6e2c1dbAd941dC69457264ABa9110Ef7D2553679',
    /* 882687 */ 8453: '0xE5A2ec9982bb890F633B5451da229683f5A7b51a',
  },
  sousChef: {
    882688: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    /* 882687 */ 8453: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    882688: '0x5790c3534F30437641541a0FA04C992799602998',
    /* 882687 */ 8453: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    /* 882687 */ 8453: '0xcA11bde05977b3631167028862bE2a173976CA11',
    882688: '0xe82A6B68e2346c5fA2b4ECa9AD1636AC871C4fEE',
  },
  pancakeProfile: {
    /* 882687 */ 8453: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    882688: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    /* 882687 */ 8453: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    882688: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    /* 882687 */ 8453: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    882688: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    /* 882687 */ 8453: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    882688: '',
  },
  pointCenterIfo: {
    /* 882687 */ 8453: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    882688: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    /* 882687 */ 8453: '0xFee8A195570a18461146F401d6033f5ab3380849',
    882688: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    /* 882687 */ 8453: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    882688: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    /* 882687 */ 8453: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    882688: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    /* 882687 */ 8453: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
    882688: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
  },
  predictions: {
    /* 882687 */ 8453: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    882688: '',
  },
  chainlinkOracle: {
    /* 882687 */ 8453: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    882688: '',
  },
  bunnySpecialCakeVault: {
    /* 882687 */ 8453: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    882688: '',
  },
  bunnySpecialPrediction: {
    /* 882687 */ 8453: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    882688: '',
  },
  bunnySpecialLottery: {
    /* 882687 */ 8453: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    882688: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    /* 882687 */ 8453: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    882688: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
}
